import React from 'react';
import { SWRConfig } from 'swr';

const SWRProvider = ({ children }) => {
  return (
    <SWRConfig
      value={{
        // ⚠️ dedupingInterval must stay BELOW every hook's refreshInterval: SWR swallows any
        // poll that fires inside the dedup window. The previous 5-minute value silently
        // neutralized all polling (bell, feeds, stats) — data only refreshed every 5 min.
        dedupingInterval: 10 * 1000,
        focusThrottleInterval: 5 * 1000, // 5 secondes
        errorRetryCount: 3,
        errorRetryInterval: 1000,

        // Désactiver la revalidation automatique (les hooks critiques la réactivent localement)
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        revalidateIfStale: false,
      }}
    >
      {children}
    </SWRConfig>
  );
};

export default SWRProvider; 